import type { ParsedTsr } from "../lib/parse";
import { Mono } from "./CopyButton";

export function TokenSummary({
  parsed,
  fileName,
}: {
  parsed: ParsedTsr;
  fileName: string;
}) {
  const info = parsed.tstInfo;
  if (!info) return null;
  const gen = new Date(info.genTime);

  return (
    <section className="panel token-summary">
      <h3>
        Timestamp details{" "}
        <span className="muted">
          ({fileName} — {parsed.kind === "token" ? "bare timestamp token" : "full TimeStampResp"},{" "}
          {parsed.totalBytes} bytes)
        </span>
      </h3>
      <dl className="kv">
        <dt>Generated (UTC)</dt>
        <dd>{gen.toISOString().replace("T", " ").replace(".000Z", "Z")}</dd>
        <dt>Generated (local)</dt>
        <dd>
          {gen.toLocaleString(undefined, { timeZoneName: "short" })}
        </dd>
        {info.accuracy && (
          <>
            <dt>Accuracy</dt>
            <dd>{fmtAccuracy(info.accuracy)}</dd>
          </>
        )}
        <dt>Hash algorithm</dt>
        <dd>
          {info.hashAlgName}
          {info.weakHashAlg && (
            <span className="warn-badge" title="This digest algorithm is considered weak">
              weak algorithm
            </span>
          )}
        </dd>
        <dt>Message imprint</dt>
        <dd>
          <Mono>{info.messageImprintHex}</Mono>
        </dd>
        <dt>Serial number</dt>
        <dd>
          <Mono>{`0x${info.serialNumberHex}`}</Mono>
        </dd>
        <dt>Policy</dt>
        <dd>
          <Mono>{info.policyOid}</Mono>
          {info.policyName && <span className="muted"> — {info.policyName}</span>}
        </dd>
        {info.nonceHex && (
          <>
            <dt>Nonce</dt>
            <dd>
              <Mono>{`0x${info.nonceHex}`}</Mono>
            </dd>
          </>
        )}
        {info.tsaName && (
          <>
            <dt>TSA</dt>
            <dd>{info.tsaName}</dd>
          </>
        )}
        <dt>Ordering</dt>
        <dd>{info.ordering ? "yes" : "no"}</dd>
      </dl>
    </section>
  );
}

function fmtAccuracy(acc: {
  seconds?: number;
  millis?: number;
  micros?: number;
}): string {
  const parts: string[] = [];
  if (acc.seconds) parts.push(`${acc.seconds} s`);
  if (acc.millis) parts.push(`${acc.millis} ms`);
  if (acc.micros) parts.push(`${acc.micros} µs`);
  return parts.length ? `± ${parts.join(" ")}` : "unspecified";
}
